
import img1 from "../../../../assets/img/Services/StrategicConsulting/14994.jpg"
import { FaCalendarAlt, FaCloud, FaCog, FaCogs, FaCompass, FaLock, FaPaintBrush, FaReact, FaUserAlt } from "react-icons/fa"
import {GoGraph} from "react-icons/go"
import {MdDevices} from "react-icons/md"

export default function PaymentServices() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
      <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Technology Advocacy
            </h1>
            <p className="text-lg text-gray-600">
            Advocate for the adoption of emerging technologies like AI, IoT, and Blockchain to accelerate business outcomes.
			      </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaCogs className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900"> Future-Ready Infrastructure</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Push for infrastructure upgrades that support emerging technologies for business growth.
			        </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdDevices className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">IoT Connectivity</h3>         
              </div>
              <p className="text-gray-600 text-sm">
              Promote IoT technologies to streamline operations and improve efficiency.
              </p>
            </div>


          </div>
        </div>

      
      </div>
    </div>
  )
}